module.exports = __webpack_public_path__ + "static/media/p-logo-sinopac.8160e8d7.svg";